import axios from 'axios';
import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import Swal from 'sweetalert2';
import DataTable from '../components/DataTable';

const ListarGrupos = ({ refresh }) => {
  const [grupos, setGrupos] = useState([]);
  const navigate = useNavigate(); // Para redirigir

  // Función para obtener los datos
  const getData = useCallback(async () => {
    try {
      const { data } = await axios.get('/api/grupos/listall/');
      if (data && Array.isArray(data.grupos)) {
        const gruposConFunciones = data.grupos.map((grupos) => ({
          ...grupos,

          nombrePrograma: grupos.programaObjectId?.nombrePrograma || "Programa no disponible",
          nombreCentro: grupos.centroObjectId?.nombreCentro || "Centro no disponible",
          nombreCiudad: grupos.ciudadObjectId?.nombreCiudad || "Ciudad no disponible",

          funciones: (
            <div className="d-flex gap-2">

              <button
                className="btn btn-warning"
                style={{ width: "30px", height: "30px", padding: "0" }}
                onClick={() => navigate(`/institucional/grupos/${grupos._id}`)}
                title='Editar Grupo'
              >
                <i className="fa-solid fa-pen-to-square"></i>
              </button>

              <button
                className="btn btn-success"
                style={{ width: "30px", height: "30px", padding: "0" }}
                onClick={() =>navigate(`/institucional/grupos/actas/registrar/${grupos._id}/${grupos.fichaGrupo}`)
                }
                title='Registrar Acta'
              >
                <i className="fa-solid fa-file-circle-plus"></i>
              </button>

              <button
                className="btn btn-outline-primary"
                style={{ width: "30px", height: "30px", padding: "0" }}
                onClick={() =>navigate(`/institucional/grupos/actas/listaractas/${grupos.fichaGrupo}`) }
                title='Listar Actas del Grupo'
               
              >
                <i className="fa-solid fa-list-check"></i>
              </button>


              <button
                className="btn btn-danger"
                style={{ width: "30px", height: "30px", padding: "0" }}
                onClick={() => deleteGrupo(grupos._id)}
                title='Eliminar Grupo'
              >
                <i className="fa-solid fa-trash"></i>
              </button>
            </div>
          ),
          // Convertir las fechas a formato adecuado
          finiciolectivaGrupo: grupos.finiciolectivaGrupo
            ? new Date(grupos.finiciolectivaGrupo).toLocaleDateString('es-CO')
            : '',
          ffinlectivaGrupo: grupos.ffinlectivaGrupo
            ? new Date(grupos.ffinlectivaGrupo).toLocaleDateString('es-CO')
            : '',
        }));
        setGrupos(gruposConFunciones.reverse());
      } else {
        throw new Error('Datos del Grupo no válidos.');
      }
    } catch (error) {
      console.error('Error al cargar los grupos:', error.message);
      Swal.fire('Error', 'No se pudo cargar la lista de grupos.', 'error');
    }
    // eslint-disable-next-line 
  }, []);

  // Ejecutar getData cuando el componente se monte
  useEffect(() => {
    getData();
  }, [getData, refresh]);

  // Función para eliminar un grupo
  const deleteGrupo = async (id) => {
    try {
      const result = await Swal.fire({
        title: '¿Está seguro?',
        text: '¡No podrá revertir este proceso!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sí, eliminar!',
      });

      if (result.isConfirmed) {
        const { data } = await axios.delete(`/api/grupos/${id}`);
        getData(); // Refrescar los datos
        Swal.fire({
          icon: 'success',
          title: data.message,
          showConfirmButton: false,
          timer: 1500,
        });
      }
    } catch (error) {
      console.error('Error al eliminar el grupo:', error.message);
      Swal.fire('Error', 'No se pudo eliminar el grupo.', 'error');
    }
  };

  // Columnas de la tabla con formato de fecha
  const columns = React.useMemo(() => [
    { Header: 'Ficha', accessor: 'fichaGrupo' },
    { Header: 'Programa', accessor: 'nombrePrograma' },
    //{ Header: 'Centro', accessor: 'nombreCentro' },
    {
      Header: 'F.I Lectiva',
      accessor: 'finiciolectivaGrupo',
      Cell: ({ value }) => (value ? value.slice(0, 10) : ''), // Formato personalizado de fecha
    },
    {
      Header: 'F.F Lectiva',
      accessor: 'ffinlectivaGrupo',
      Cell: ({ value }) => (value ? value.slice(0, 10) : ''), // Formato personalizado de fecha
    },
    { Header: 'Ciudad', accessor: 'nombreCiudad' },
    { Header: 'Estado', accessor: 'estadoGrupo' },
    { Header: 'Acciones', accessor: 'funciones' },

  ], []);

  return (
    <div className="container-fluid py-1 px-0 shadow-lg rounded-4 bg-light mt-5">
      <h1>Lista de Grupos</h1>
      {Array.isArray(grupos) && grupos.length > 0 ? (
        <DataTable columns={columns} data={grupos} />
      ) : (
        <p>Cargando Grupos...</p>
      )}
    </div>
  );
};

export default ListarGrupos;
